export function getYouTubeId(url: string): string | undefined {
    const regex = /(?:youtube(?:-nocookie)?\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const result = regex.exec(url);

    if (result && result.length > 1) {
        return result[1];
    }

    return undefined;
}